import Media from "react-media";
import { useContext } from "react";
import styled from "styled-components";
import { UserContext } from "../../../../context";
import logo_yayasan from "../../../../assets/logo_yayasan.png";
import logo_sekolah from "../../../../assets/logo_sekolah.png";
import { Image } from "semantic-ui-react";

const MoleculeSekolah = () => {
  const { state } = useContext(UserContext);
  return (
    <Media query={{ maxWidth: 768 }}>
      {(v) =>
        v ? null : (
          <Style nav={state.navigation.active ? true : state.navigation.hover}>
            <div className="logo-yayasan">
              <Image src={logo_yayasan} />
            </div>
            <div className="logo-sekolah">
              <Image src={logo_sekolah} />
            </div>
          </Style>
        )
      }
    </Media>
  );
};

const Style = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.nav ? "37px auto" : "1fr")};
  gap: 16px;
  padding: 16px;
  align-items: center;
  height: 54px;

  div > img {
    width: 2.8em;
  }

  .logo-sekolah img {
    width: 8em;
    display: ${(props) => (props.nav ? "block" : "none")};
  }

  @media (max-width: 480px) {
    grid-template-columns: ${(props) =>
      props.nav ? "37px auto" : "37px auto"};
    gap: 10px;
    padding: 0;

    .dashboard-header {
      display: block;

      p {
        font-size: 12px;
        display: block;
      }
    }
  }
`;

export default MoleculeSekolah;
